export default "__VITE_ASSET__CeePX0Rz__"